<template>
  <div class="main-container">
    <div class="container header">
      <h1>
        {{ getMessage('MSG_SUPERASTE_TIEMPO_INACTIVIDAD') }}
        <br />
        {{ getMessage('MSG_QUERES_CONTINUAR') }}
      </h1>
    </div>
    <div class="container">
      <router-link :to="{ name: from }" tag="button" class="btn-secondary"> {{ getMessage('BTN_SI') }}</router-link>
      <router-link :to="{ name: 'TotemHome' }" tag="button" class="btn-secondary">
        <span @click="goHome">{{ getMessage('BTN_NO') }}</span>
      </router-link>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
export default {
  props: {
    from: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('GeneralAR', ['getMessage'])
  },
  data () {
    return {
      idleTimeWithAlert: 8000
    }
  },
  mounted: function () {
    this.backHome()
  },
  methods: {
    backHome: function () {
      var vm = this
      setTimeout(function () {
        var currentRouteName = vm.$router.currentRoute.name
        if (currentRouteName === 'IdleScreen') {
          vm.$router.push({ name: 'TotemHome' })
        }
        vm.prolongTime = false
      }, vm.idleTimeWithAlert)
    },
    goHome () {
      this.$store.commit('GeneralAR/setHomeLastState', {})
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './styles.scss';
</style>
